// extracted by mini-css-extract-plugin
export default {"magicLinkContainer":"MagicLink_magicLinkContainer__qu+C6","magicLinkHeading":"MagicLink_magicLinkHeading__uvZuP","inputsContainer":"MagicLink_inputsContainer__Q-8MJ"};